export const numberOfSisters = {
	title: 'বোন কয়জন?*',
	selected: {
		value: '',
		option: '----'
	},
	options: ['বোন নেই','১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯', '১০'],
};
export const numberOfBrothers = {
	title: 'ভাই কয়জন?*',
	selected: {
		value: '',
		option: '----',
	},
	options: ['ভাই নেই','১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯', '১০'],
};